import { NavItem } from "@components/NavBar/NavItem";
import { mainNavigation } from "@constants/routes";
import { usePortalPermissions } from "@hooks/usePortalPermissions";
import { toFeatureList, useProfile } from "@lyteflo/utils";
import { getMobileNavHeight, getMobilePaddingY } from "@utils/layout";
import { useMemo } from "preact/compat";
import { useTranslation } from "react-i18next";

export const Navbar = ({ className = "" }: { className?: string }) => {
  const { t } = useTranslation();
  const { profile } = useProfile();
  const { hasAnyPermission } = usePortalPermissions();
  const paddingY = getMobilePaddingY();

  const filteredNavigation = useMemo(() => {
    if (!profile) return mainNavigation;

    return mainNavigation.filter(({ feature, hidden }) =>
      hidden ? false : !feature || hasAnyPermission(toFeatureList(feature)),
    );
  }, [profile, hasAnyPermission]);

  return (
    <>
      <nav
        className={`lf-fixed lf-bottom-0 lf-w-full lf-bg-background lf-border-t-2 lf-border-t-[var(--gray-3)] lf-z-40 md:lf-fixed md:lf-border-none md:lf-pt-1 md:lf-px-6 md:lf-bottom-auto md:lf-z-[-1] ${className}`}
      >
        <div
          className="lf-grid lf-w-full md:lf-flex md:lf-w-auto md:lf-gap-x-6 md:lf-justify-start md:lf-pb-0"
          style={{
            paddingTop: `${paddingY}px`,
            paddingBottom: `${paddingY}px`,
            gridTemplateColumns: `repeat(${filteredNavigation.length}, minmax(0, 1fr))`,
          }}
        >
          {filteredNavigation.map(
            ({ labelKey, href, Icon, iconClassName, iconColorClassName }) => {
              if (!Icon) return null;
              return (
                <NavItem
                  key={labelKey}
                  name={t(labelKey)}
                  href={href}
                  Icon={Icon}
                  iconClassName={iconClassName}
                  iconColorClassName={iconColorClassName}
                />
              );
            },
          )}
        </div>
      </nav>
      {/* mobile bottom nav spacer */}
      <div
        style={{ height: `${getMobileNavHeight()}px` }}
        className="lf-bottom-0 lf-left-0 lf-right-0 md:lf-hidden"
      />
    </>
  );
};
